<template>
	<div class="emb-forgetpassword-wrap section-gap">
		<div class="container py-0">
			<v-layout row wrap align-center justify-center>
				<v-flex sm12 md12 lg8 xl8>
					<v-layout align-center mx-sm-0 mx-3  justify-center row wrap>
						<v-flex sm6 md6 lg6 xl6 hidden-sm-and-down>
							<div class="forgot-password-image form-img" :style="'background-image: url('+ forgotSection.Image_800x1202_px +');'">
							</div>
						</v-flex>
						<v-flex sm10 md6 lg6 xl6 class="emb-card form-margin pa-4 d-inline-block white">
							<h3 class="accent--text">{{forgotSection.Title}}</h3>
							<h4>{{forgotSection.Sub_Title}}</h4>
							<v-form >
								<v-text-field  v-model="email" type="email"  :placeholder="forgotSection.Email_Placeholder">
								</v-text-field>
									<v-btn class="accent mb-4 ma-0" large @click.stop.prevent="saveDetails">
									{{forgotSection.Button_Label}}
								</v-btn>
								<p>{{forgotSection.Have_an_account_Label}} <router-link :to=" forgotSection.Sign_In_Path"  class="accent--text">{{forgotSection.Sign_In_Label}}
									</router-link>
								</p>
							</v-form>
						</v-flex>
					</v-layout>
				</v-flex>
			</v-layout>
		</div>
	</div>
</template>

<script>
    import Vue from 'vue';
    import gettingRestClientObject from "../../../services/utils/cms-helper" ;
    import VueAlertify from 'vue-alertify';
   Vue.use(VueAlertify);
	export default {
		data() {
			return {
				valid: false,
				cmsRequestFunctions:'',
				email:'',
				forgotSection:''
			}
	
		},
		mounted() {
	
	     this.cmsRequestFunctions = gettingRestClientObject();
	     this.getPageData();
       },
		methods: {
			saveDetails() {
				
                if (this.email == '') {
		Vue.$toast.warning(self.cmsRequestFunctions.getValidationMsgByCode('M007'));
        return false;
      }
      var emailPat = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/;
      var matchArray = this.email.match(emailPat);
      if (matchArray == null) { 

		  Vue.$toast.warning(self.cmsRequestFunctions.getValidationMsgByCode('M010'));
	  }
	  window.location="/session/signin";
					},
					
					
  getPageData: function() {

var self=this;
var language = localStorage.Language? localStorage.Language : "en";

var config = {
pageType: "Template/",
pageUrl : "08 Forgot Password/08 Forgot Password/08 Forgot Password.ftl",
lang :language,

successCallback: function(response) {
var res = response.data;
if (res.area_List) {
			var forgot = self.cmsRequestFunctions.pluck("Forgot_Section",res.area_List);
			self.forgotSection = self.cmsRequestFunctions.getAllMapData(forgot[0].component);
			
			}
},
errorCallback: function(error) {
console.log(error);
}
};
this.cmsRequestFunctions.cmsRequest(config,language);
},
  },
		
	}
</script>